import type { ColorSource, Graphics } from 'pixi.js';
import { Side } from '@/schemas/tiles';
import { pixelRect } from './tilePixels';
import {
  wirePixelGeometry,
  cablePixelGeometry,
  cableStripePixelGeometry,
  type WireRect,
} from './wireGeometry';

const sides = [Side.TOP, Side.RIGHT, Side.BOTTOM, Side.LEFT];
type Connections = Partial<Record<Side, boolean>>;

export function connectionMask(connections: Connections) {
  return sides.reduce((mask, side, i) => mask | (connections[side] ? 1 << i : 0), 0);
}

/** Only two adjacent ports form a bend. Kept separate from junction treatment. */
export function wireTurnRotation(connections: Connections) {
  if (sides.filter((side) => connections[side]).length !== 2) return undefined;
  const turn = sides.findIndex(
    (side, index) => connections[side] && connections[sides[(index + 1) % 4]],
  );
  return turn < 0 ? undefined : turn;
}

function draw(g: Graphics, rects: readonly WireRect[], color: ColorSource) {
  for (const [x, y, width, height] of rects) pixelRect(g, x, y, width, height, color);
}

export function drawWireTopology(
  g: Graphics,
  connections: Connections,
  color: ColorSource,
) {
  draw(g, wirePixelGeometry[connectionMask(connections)], color);
}

export function drawCableTopology(
  g: Graphics,
  connections: Connections,
  color: ColorSource,
) {
  const mask = connectionMask(connections);
  draw(g, cablePixelGeometry[mask], color);
  draw(g, cableStripePixelGeometry[mask], 0x2a1112);
}
